import * as React from "react";
const SvgRestart20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6.6 10 16 3.73v12.54L6.6 10Zm3.6 0 3.8 2.53V7.47L10.2 10Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", { fill: "current", d: "M4 4v12h2V4H4Z" })
  );
export default SvgRestart20Px;
